module.exports = __webpack_public_path__ + "img/Bottone-Crea-Intervento.6c22754a.jpg";